import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FloatingActions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLoadingOverlay"] */ "/app/src/components/NavigationLoading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TranslationProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layouts/footer/lazy-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layouts/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/promo-sticky-bar.css");
